var map = {
	"./bgm/00-suicidal.ogg": 3658,
	"./bgm/01-depressed.ogg": 5827,
	"./bgm/02-sad.ogg": 8224,
	"./bgm/03-calm.ogg": 8690,
	"./bgm/04-happy.ogg": 5011,
	"./bgm/05-excited.ogg": 787,
	"./bgm/06-manic.ogg": 6122,
	"./sfx/bloing.ogg": 7844,
	"./sfx/crying.ogg": 4016,
	"./sfx/deathwithvomit.ogg": 1598,
	"./sfx/explosion.ogg": 9862,
	"./sfx/randomclick.ogg": 9257,
	"./sfx/scarydeathsound.ogg": 1050,
	"./sfx/syringe.ogg": 2352,
	"./sfx/text-calm1.ogg": 7467,
	"./sfx/text-happy1.ogg": 6588,
	"./sfx/text-happy2.ogg": 1083,
	"./sfx/text-manic1.ogg": 4400,
	"./sfx/text-manic2.ogg": 52,
	"./sfx/text-manic3.ogg": 7754,
	"./sfx/text-sad1.ogg": 6586,
	"./sfx/text-sad2.ogg": 469,
	"./sfx/text-suicidal1.ogg": 2717,
	"./sfx/vomit.ogg": 2427
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2974;